import React, {FC} from 'react';
import {MdDelete} from 'react-icons/md';
import {getDebug, isMasterFirebaseUser} from '../../../../library/GeneralUse';
import {decrementPostCount} from '../../../../library/FirestoreUser';
import {deletePostDocument} from '../../../../library/PostsCollection';
import {useFirebaseAuthUserStore} from '../../../../stores/FirebaseAuthUserStore';
import {usePostsStore} from '../../../../stores/PostsStore';

const style = {
	admin: `flex flex-row basis-1/2   pt-1`,
	container: `flex flex-col gap-y-2   p-4   text-whirlwindLightest   bg-whirlwindDarkest   divide-y-4 divide-whirlwindDark   rounded-md   opacity-90`,
	deleteButton: `text-whirlwindRed hover:text-whirlwindRedDark   opacity-90`,
	footer: `flex flex-row   pt-1`,
	header: `flex flex-row justify-end items-center`,
	post: `pt-1   break-words`,
	time: `basis-1/2   pt-1   text-xs text-right`,
	username: `font-semibold text-lg text-whirlwindPrimaryLight`,
};

type PostFooterProps = {
	created_at: string;
	documentId: string;
	uid: string;
};

const DEBUG = getDebug('posts');

export const PostFooter: FC<PostFooterProps> = ({
	created_at,
	documentId,
	uid,
}) => {
	// Zustand
	const firebaseAuthUser = useFirebaseAuthUserStore(
		(state) => state.firebaseAuthUser,
	);
	const posts = usePostsStore((state) => state.posts);
	const setPosts = usePostsStore((state) => state.setPosts);

	// Component methods
	const handleDelete = async () => {
		DEBUG && console.clear();
		DEBUG && console.trace(`Post handleDelete()`);

		try {
			await deletePostDocument(documentId);

			if (firebaseAuthUser?.uid === uid) {
				// This is pretty much only for the scenario when the master Firebase Auth user deletes a Post that is not theirs.
				await decrementPostCount();
			}

			const updatedPosts = posts?.filter(
				(docSnap) => docSnap.id !== documentId,
			);
			if (updatedPosts && updatedPosts != posts) {
				setPosts(updatedPosts);
			}
		} catch (error) {
			DEBUG && console.error(error);
		}
	};

	return (
		<div className={style.footer}>
			<div className={style.admin} data-test-id={`${documentId}_PostAdmin`}>
				{uid === firebaseAuthUser?.uid ||
				isMasterFirebaseUser(firebaseAuthUser?.uid) ? (
					<button
						className={style.deleteButton}
						data-test-id={`${documentId}_PostDelete_TEST`}
						onClick={async () => {
							await handleDelete();
						}}>
						<MdDelete size={24} />
					</button>
				) : (
					<></>
				)}
			</div>
			<span className={style.time}>
				<p>{created_at}</p>
			</span>
		</div>
	);
};
